// extracted by mini-css-extract-plugin
export var boxItems = "_6k-1";
export var boxItemsLg = "_6k-2";
export var button = "_6k-7";
export var buttonHoverless = "_6k-9";
export var buttonLg = "_6k-8";
export var filterGroupBox = "_6k-0";
export var icon = "_6k-3";
export var iconSecondary = "_6k-6";
export var iconWrapper = "_6k-4";
export var iconWrapperLg = "_6k-5";
export var truncatedLabel = "_6k-a";